
import { useCallback, useEffect, useMemo, useState } from "react";
import ReactDOM from 'react-dom';
import "chartjs-adapter-date-fns";
import {endOfYesterday, startOfMonth} from "date-fns";

import { useMediaQuery, LinearProgress } from "@mui/material";

import { PaperChartCustom } from '../../../../Theme/ContainerStyle';
import { formatDateForServer } from "../../../../lib/Utility";
import useAuthenticatedRequest from "../../../../lib/useAuthenticatedRequest";
import{ generateDatasetsPie } from "../generateDatasets";
import ModalVariables from "../ModalVariables";
import { EnergyFooter } from "../EnergyFooter";
import { PERIODS } from '../settings';
import { ChartPiePC } from './ChartPiePc';
import { ChartPieSmart } from './ChartPieSmart';

export default function IndexPie(props) {
  const sizeMedia = useMediaQuery('(min-width:800px)');
  const {site, variablesList} = props

  const [{isLoading, data: chartDataResponse}, triggerRequest] = useAuthenticatedRequest();

  const [variables, setVariables] = useState(
    variablesList.reduce(
      (acc, {color, variable}) => ({
        ...acc,
        [variable.variable_id]: {
          id: variable.variable_id,
          color,
          name: [variable.device_name].join(" - "),
          hash: variable.variable_hash,
          avg: undefined,
        }
      }),{}
    )
  );
  const fromStartOfMonth = (startOfMonth(new Date()) > endOfYesterday()) ? startOfMonth(endOfYesterday()) : startOfMonth(new Date());
  const toEndOfYesterday = endOfYesterday();

  // Recupera i valori dal localStorage o imposta i valori predefiniti
  const initialReportFromDate = sessionStorage.getItem('reportFromDate') ? new Date(sessionStorage.getItem('reportFromDate')) : fromStartOfMonth;
  const initialReportToDate = sessionStorage.getItem('reportToDate') ? new Date(sessionStorage.getItem('reportToDate')) : toEndOfYesterday;
  const initialSelectedFrequency = sessionStorage.getItem('selectedFrequency') || "24h";
  const initialCheckedVariables = sessionStorage.getItem('checkedVariables') ? JSON.parse(sessionStorage.getItem('checkedVariables')) : Object.keys(variables).map(Number);
  const initialSelectedPeriod = sessionStorage.getItem('selectedPeriod') ? sessionStorage.getItem('selectedPeriod') : PERIODS.LAST_MONTH;

  const [checkedVariables, setCheckedVariables] = useState(initialCheckedVariables);
  const [chartVars, setChartVars] = useState([])

  const [selectedPeriod, setSelectedPeriod] = useState(initialSelectedPeriod || PERIODS.LAST_MONTH);
  const [selectedFrequency, setSelectedFrequency] = useState(initialSelectedFrequency || "24h");
  const [reportToDate, setReportToDate] = useState(initialReportToDate || toEndOfYesterday);
  const [reportFromDate, setReportFromDate] = useState(initialReportFromDate || fromStartOfMonth);

  useEffect(() => {
    if(chartDataResponse !== null){
      const vars = (chartDataResponse.vars).filter(item => checkedVariables.includes(item.idvar))
      setChartVars(vars)
    }   
  }, [chartDataResponse,checkedVariables]);

  ////FUNZIONE PER LA RICERCA IN BASE ALLA DATA
  const search = useCallback(() => {
    if (checkedVariables.length > 0) {

      const data = {
        siteID: Number(site.id),
        categoryID: 1, // 1 -> Energy
        step: selectedFrequency,
        dateStart: formatDateForServer(reportFromDate.toISOString()),
        dateEnd: formatDateForServer(reportToDate.toISOString()),
        ids: checkedVariables.map(String),
      };
      triggerRequest({method: "POST", url: "chart-bar-data",data});
    }
    sessionStorage.setItem('reportFromDate', reportFromDate.toISOString());
    sessionStorage.setItem('reportToDate', reportToDate.toISOString());
    sessionStorage.setItem('selectedFrequency', selectedFrequency);
    sessionStorage.setItem('checkedVariables', JSON.stringify(checkedVariables));
    sessionStorage.setItem('selectedPeriod', selectedPeriod);
  },[checkedVariables, reportFromDate, reportToDate, selectedFrequency, site.id, triggerRequest,selectedPeriod]);

  useEffect(() => {
    search();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportFromDate, reportToDate, selectedFrequency]);

  const onChangeVariableSelection = useCallback((variableId, checked) => {
    setCheckedVariables(checked ? checkedVariables.concat(variableId) :
      checkedVariables.filter(id => id !== variableId));
  },[checkedVariables]);

  ////DESELEZIONA O SELEZIONA TUTTE LE VARIABILI NELLA MODALE
  const onSelectDeselectAllVariables = useCallback((checked) => {
    setCheckedVariables(checked ? Object.keys(variables).map(Number) : []);
  },[variables]);

 ////FUNZIONE PER CAMBIARE, NELLA MODALE DELLE VARIABILI, IL COLORE NEL GRAFICO
  const onChangeVariableColor = useCallback((variableId, color) => {
    setVariables({
      ...variables,
      [variableId]: {
        ...variables[variableId],
        color,
      },
    });
  },[variables]);

  const researchedVariables = (chartDataResponse?.vars || []).map(vars => (  vars.idvar));  
  const titleVariables = `Variabili: ${checkedVariables.length} di ${variablesList.length} selezionate`

  const configModalVariables = {
    configModal: {
      defaultExpanded:true,
      sxStyle:{width: { xs: "100%", sm: "30%" }},
      search:search,
    },
    configVariablesGrid: {
      variables:variables,
      checkedVariables:checkedVariables,
      researchedVariables:researchedVariables,
      onChangeSelection:onChangeVariableSelection,
      onChangeColor:onChangeVariableColor,
      onSelectDeselectAll:onSelectDeselectAllVariables,
      showAvg:false,
      title:titleVariables,
    }
  }

  const datasets = useMemo(() => {
    const vars = generateDatasetsPie(chartVars || [], variables)
    return [
      { name: "currentData", dataset: vars },
    ]; 
  },[chartVars,  variables]);
  
  const modalPortal = document.getElementById('modal-portal');

  const footerProps = {selectedFrequency, reportToDate, reportFromDate, 
    site, checkedVariables, selectedPeriod, 
    setReportFromDate, setReportToDate, setSelectedFrequency,  setSelectedPeriod}

  return (
    <>
      {isLoading  &&  <LinearProgress/>}
      <PaperChartCustom className="chart-area">
        {sizeMedia && <ChartPiePC datasets={datasets}/>}
        {!sizeMedia && <ChartPieSmart datasets={datasets} />}
      </PaperChartCustom>
      {modalPortal && ReactDOM.createPortal(
        <ModalVariables {...configModalVariables}/>,
        modalPortal
      )}
      <EnergyFooter {...footerProps}/>
    </>
  )
}


